export default {
    cn: {
        salesCommission: {
            unconfirmed: '未审核的',
            confirmed: '已审核的',
            operate: '操作',
            templateSetting: '模板管理',
            templateName: '模板名称',
            templateHistory: '模板历史',
            templateCreate: '新建模板',
            templateBase: '基础模板',
            preview: {
                subordinateType: '下属类型',
                all: '全部',
                directCustomer: '直接客户',
                directIB: '直接代理',
                other: '其他',
                search: '搜索',
                showClauses: '显示条目数',
                totalClauses: '条目总数',
                current: '当前',
            },
            contrastBrowse: '对比浏览',
            singlepageBrowse: '单页浏览',
            salesCommissionSetting: '销售佣金设定',
            updateBy: '最后修改',
            confirmBy: '最后审核',
            roleCode: {
                UM: '系统',
                C: '公司',
                N: '国家',
                R: '地区',
                O: '办事处',
                M: '经理',
                SL: '销售',
                IB: '代理',
                CL: '客户'
            },
            alertMsg: {
                noAccount: '这不是一个正确的账号',
                alreadyExist: '已经存在了',
                IBNotFound: '查不到该代理账号',
                employeeNotFound: '查不到该员工账号',
                verifyTips: '是否确定审核，如果数据有修改，请先保存，否则将被覆盖!',
                checkFail: '不能由同一人完成修改和审核',
                beforeSave: '请先保存数据',
                checkRuleFail1: '分配账号设定不同。',
                checkRuleFail2: '固定金额与固定金额(普通组别)、固定金额(VIP 组别)不能同时选择。',
                checkRuleFail3: '相同规则下，全部客户类型与其他客户类型冲突。',
                checkRuleFail4: '存在重复的规则设定。',
                checkRuleFail5: '存在“分层最高金额”这个规则时，每个级别都必须有一条“分层最高金额”，并保证“客户类型”一致。',
                templateExist: '模板名已存在!',
            },
            saleAccount: '销售账号',
            excelTh: {
                type: '类型',
                Account: '收取佣金的账号',
                name: '收取佣金人姓名',
                ID: '其下属账号',
                TYPE: '其下属类型',
                REBATE: '收取佣金金额(美元/手)',
            },
            downloadExcel: '下载 Excel',
            virtualAccout: '虚拟账号',
            virtualIB: '虚拟代理',
            noData: '没有数据',
            recordCount: '条记录',
            crumbs: {
                amend: "佣金修改",
            },
            submitResult: {
                err: '请正确填写信息',
                succeed: '成功保存',
                auditSuccess: '审核成功',
                serverErr: '提交失败'
            },
            enable: '启用',
            costPerCommission: '每手佣金',
            btnGroup: {
                submit: '保存修改',
                add: '添加',
                remove: '删除',
                confirmDeleteText: '确认删除所选记录吗？',
                commissionPreviewBtn: '佣金预览',
                back: '返回',
                addLevel: '添加级别',
                removeLevel: '删除级别',
                check: '确认审核',
                backData: '返回之前数据'
            },
            overlookIB: '被忽略的代理',
            ibAccount: '代理账号',
            ibName: '代理姓名',
            allLowIB: '所有下层代理',
            specialIB: '特别代理佣金分配',
            filteText: '下属类型',
            seekPlaceholder: '搜索',
            seekBtnText: '搜索',
            previewThead: [
                { text: '主账号' },
                { text: '下层类型' },
                { text: '下层账号' },
                { text: '下层姓名' },
                { text: '关系类型' },
                { text: '主账号获取下层账号佣金条件' },
            ],
            lowType: [
                { key: "特别代理", val: 'specialIB' },
                { key: "代理", val: 'IB' },
                { key: "额外员工", val: 'extraEmployee' },
                { key: "员工", val: 'employee' },
            ],
            settingTemplate: '设定模板',
            sales_sales: '员工设定',
            sales_manager: '经理设定',
            sales_uae_level_1: 'LEVEL 1',
            sales_uae_level_2: 'LEVEL 2',
            sales_uae_level_3: 'LEVEL 3',
        }
    },
    hk: {
        salesCommission: {
            unconfirmed: '未審核的',
            confirmed: '已審核的',
            operate: '操作',
            templateSetting: '模板管理',
            templateName: '模板名称',
            templateHistory: '模板历史',
            templateCreate: '新建模板',
            templateBase: '基礎模板',
            preview: {
                subordinateType: '下屬類型',
                all: '全部',
                directCustomer: '直接客戶',
                directIB: '直接代理',
                other: '其他',
                search: '搜索',
                showClauses: '顯示條目數',
                totalClauses: '條目總數',
                current: '當前',
            },
            contrastBrowse: '對比瀏覽',
            singlepageBrowse: '單頁瀏覽',
            salesCommissionSetting: '銷售佣金設定',
            updateBy: '最后修改',
            confirmBy: '最后審核',
            roleCode: {
                UM: '系統',
                C: '公司',
                N: '國家',
                R: '地區',
                O: '辦事處',
                M: '經理',
                SL: '銷售',
                IB: '代理',
                CL: '客戶'
            },
            alertMsg: {
                noAccount: '這不是一個正確的賬號',
                alreadyExist: '已經存在了',
                IBNotFound: '查不到代理賬號',
                employeeNotFound: '查不到員工賬號',
                verifyTips: '是否確定審核，如果數據有修改，請先保存，否則將被覆蓋!',
                checkFail: '不能由同一人完成修改和審核',
                beforeSave: '請先保存數據',
                checkRuleFail1: '分配賬號設定不同。',
                checkRuleFail2: '固定金額與固定金額（普通組別）、固定金額（VIP 組別）不能同時選擇。',
                checkRuleFail3: '相同規則下，全部客戶類型與其他客戶類型沖突。',
                checkRuleFail4: '存在重復的規則設定。',
                checkRuleFail5: '存在“分層最高金額”這個規則時，每個級別都必須有一條“分層最高金額”，并保證“客戶類型”一致',
                templateExist: '模板名已存在!',
            },
            saleAccount: '銷售賬號',
            excelTh: {
                type: '類型',
                Account: '收取佣金賬號',
                name: '收取佣金人姓名',
                ID: '其下屬賬號',
                TYPE: '其下屬類型',
                REBATE: '收取佣金金額(美圓/手)',
            },
            downloadExcel: '下載 Excel',
            virtualAccout: '虛擬賬號',
            virtualIB: '虛擬代理',
            noData: '沒有數據',
            recordCount: '條記錄',
            crumbs: {
                amend: "佣金修改",
            },
            submitResult: {
                err: '請正確填寫信息',
                succeed: '成功保存',
                auditSuccess: '審核成功',
                serverErr: '提交失敗'
            },
            enable: '啟用',
            costPerCommission: '每手佣金',
            btnGroup: {
                submit: '保存修改',
                add: '添加',
                remove: '删除',
                confirmDeleteText: '確認刪除所選記錄嗎？',
                commissionPreviewBtn: '佣金預覽',
                back: '返回',
                addLevel: '添加級別',
                removeLevel: '刪除級別',
                check: '確認審核',
                backData: '返回之前數據'
            },
            overlookIB: '被忽略的代理',
            ibAccount: '代理賬號',
            ibName: '代理姓名',
            specialIB: '特別代理佣金分配',
            allLowIB: '所有下層代理',
            filteText: '下屬類型',
            seekPlaceholder: '搜索',
            seekBtnText: '搜索',
            previewThead: [
                { text: '主賬號' },
                { text: '下層類型' },
                { text: '下層賬號' },
                { text: '下層姓名' },
                { text: '關系類型' },
                { text: '主賬號獲取下層賬號傭金條件' },
            ],
            lowType: [
                { key: "特別代理", val: 'specialIB' },
                { key: "代理", val: 'IB' },
                { key: "額外員工", val: 'extraEmployee' },
                { key: "員工", val: 'employee' },
            ],
            settingTemplate: '設定模版',
            sales_sales: '員工設定',
            sales_manager: '經理設定',
            sales_uae_level_1: 'LEVEL 1',
            sales_uae_level_2: 'LEVEL 2',
            sales_uae_level_3: 'LEVEL 3',
        }
    },
    en: {
        salesCommission: {
            unconfirmed: 'unconfirmed',
            confirmed: 'confirmed',
            operate: 'operate',
            templateSetting: 'Template Maintenance',
            templateName: 'Template Name',
            templateHistory: 'Template History',
            templateCreate: 'New Template',
            templateBase: 'Base Template',
            preview: {
                subordinateType: 'Subordinate Type',
                all: 'ALL',
                directCustomer: 'Direct Customer',
                directIB: 'Direct IB',
                other: 'Other',
                search: 'Search',
                showClauses: 'Display Record Count',
                totalClauses: 'Record Total Count',
                current: 'Current',
            },
            contrastBrowse: 'Contrast Browse',
            singlepageBrowse: 'Singlepage Browse',
            salesCommissionSetting: 'Sales Commission Setting',
            updateBy: 'UpdateBy',
            confirmBy: 'ConfirmBy',
            roleCode: {
                UM: 'UM',
                C: 'COMPANY',
                N: 'COUNTRY',
                R: 'REGION',
                O: 'OFFICE',
                M: 'MANAGER',
                SL: 'SALES',
                IB: 'IB',
                CL: 'CLIENT'
            },
            alertMsg: {
                noAccount: 'Invalid Account',
                alreadyExist: 'Already exists',
                IBNotFound: 'IB account not found',
                employeeNotFound: 'Employee account not found',
                verifyTips: 'Whether to confirm audit, if the data has been modified, please save first, otherwise it will be overwritten!',
                checkFail: 'Can not check Modification and inspection by same person',
                beforeSave: 'Please save the data first',
                checkRuleFail1: 'Check Rule Setting Fail : 1',
                checkRuleFail2: 'Check Rule Setting Fail : 2',
                checkRuleFail3: 'Check Rule Setting Fail : 3',
                checkRuleFail4: 'Check Rule Setting Fail : 4',
                checkRuleFail5: 'Check Rule Setting Fail : 5',
                templateExist: 'Template Name Already Exist!',
            },
            saleAccount: 'Sales Account',
            excelTh: {
                type: 'Type',
                Account: 'Get Commission Account',
                name: 'Get Commission Name',
                ID: 'Subordinate Account',
                TYPE: 'Subordinate Type',
                REBATE: 'Get Cost Per Commission(Lots)',
            },
            downloadExcel: 'Download Excel',
            virtualAccout: 'Virtual Accout',
            virtualIB: 'Virtual IB',
            noData: 'No data',
            recordCount: 'record',
            crumbs: {
                amend: "Amend Commission",
            },
            submitResult: {
                err: 'Please fill in the information correctly',
                succeed: 'Save successfully',
                auditSuccess: 'Check Successfully',
                serverErr: 'Submit failed!'
            },
            enable: 'Enable',
            costPerCommission: 'Cost Per Commission',
            btnGroup: {
                submit: 'Save',
                add: 'Add',
                remove: 'Remove',
                confirmDeleteText: 'Are you sure to delete this record?',
                commissionPreviewBtn: 'Commission preview',
                back: 'Back',
                addLevel: 'Add Level',
                removeLevel: 'Remove Level',
                check: 'Check',
                backData: 'Back To Before Data'
            },
            overlookIB: 'Overlook IB',
            ibAccount: 'IB Account',
            ibName: 'IB Name',
            specialIB: 'Special IB',
            allLowIB: 'All Low IB',
            filteText: 'Low Type',
            seekPlaceholder: 'Search',
            seekBtnText: 'Search',
            previewThead: [
                { text: 'Main Account' },
                { text: 'Subordinate Type' },
                { text: 'Subordinate Account' },
                { text: 'Subordinate Name' },
                { text: 'Relation Type' },
                { text: 'Main Account To Obtain The Subordinate Account Commission Conditions' },
            ],
            lowType: [
                { key: "SpecialIB", val: 'specialIB' },
                { key: "IB", val: 'IB' },
                { key: "Extra Employee", val: 'extraEmployee' },
                { key: "Employee", val: 'employee' },
            ],
            settingTemplate: 'Setting Template',
            sales_sales: 'Sales Rebate',
            sales_manager: 'Manager Rebate',
            sales_uae_level_1: 'LEVEL 1',
            sales_uae_level_2: 'LEVEL 2',
            sales_uae_level_3: 'LEVEL 3',
        }
    }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/Sale/salesCommission.js